// extracted by mini-css-extract-plugin
export default {"outer":"SplitLine_outer__wDzN7","small":"SplitLine_small__071e6","wrapper":"SplitLine_wrapper__64q0K","text":"SplitLine_text__jxArG","white":"SplitLine_white__zXaMN"};